import { useSession } from '@faststore/sdk'
import { useCallback, useEffect } from 'react'
import { BK_ID_STORAGE_KEY } from 'src/sdk/session/validate'
import {
  COOKIEBOT_ACCEPT,
  COOKIEBOT_DECLINE,
  COOKIEBOT_READY,
} from '../ThirdPartyScripts/DynamicYieldScriptLoader'
import { ALGOLIA_COOKIE_DURATION } from './searchbarQueries'

export const UserTokenConsentHandler = () => {
  const { person } = useSession()

  const deleteCookie = (name: string) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${location.hostname}`
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${location.hostname}`
  }

  // const deleteCookieFromLocalStorage = () => {
  //   localStorage.removeItem(ALGOLIA_USER_TOKEN)
  // }

  // const getCookieFromLocalStorage = () => {
  //   return localStorage.getItem(ALGOLIA_USER_TOKEN)
  // }

  const getCookieFromDocument = () => {
    return document?.cookie
      .split(';')
      ?.map((item) => item.trim())
      ?.find((cookie) => cookie.startsWith('_ALGOLIA'))
      ?.split('=')?.[1]
  }

  const setAuthenticatedUserTokenConsent = useCallback(
    (hasConsent: boolean) => {
      if (!hasConsent) {
        window?.aa?.('setAuthenticatedUserToken', undefined) // without consent, we remove the authenticated user token
        return
      }

      // Otherwise we set the authenticated user token aswell, if user is logged in
      const userData = JSON.parse(
        window.localStorage.getItem(BK_ID_STORAGE_KEY) || '{}'
      )
      const bkId = userData.bk_id
      if (bkId && window.aa) {
        window.aa(
          'getAuthenticatedUserToken',
          {},
          (err: Error, authenticatedUserToken: string) => {
            if (err) {
              console.error(err, 'error-usertoken')
              return
            }
            if (authenticatedUserToken === bkId) {
              return
            }
            window.aa('setAuthenticatedUserToken', bkId)
          }
        )
      }
    },
    []
  )

  const setUserTokenConsent = useCallback((hasConsent: boolean) => {
    if (!hasConsent) {
      // deleteCookieFromLocalStorage() // We delete the cookie from the localStorage
      deleteCookie('_ALGOLIA') // We delete the cookie from the document
      window?.aa?.('init', {
        partial: true,
        userHasOptedOut: true,
        useCookie: false,
      }) // Block every event sent to Algolia
    } else {
      if (!getCookieFromDocument()) {
        window?.aa?.('setAnonymousUserToken')
      }
      // if (!getCookieFromLocalStorage()) {
      //   window.aa('setAnonymousUserToken')
      //   const userToken = getCookieFromDocument()
      //   if (!userToken) return

      //   localStorage.setItem(ALGOLIA_USER_TOKEN, userToken)
      // }
      window?.aa?.('init', {
        partial: true,
        userHasOptedOut: false,
        useCookie: true,
        cookieDuration: ALGOLIA_COOKIE_DURATION,
      }) // Allow every event sent to Algolia and set the user token as persistent cookie
    }
  }, [])

  useEffect(() => {
    if (person && typeof window !== 'undefined' && window.Cookiebot?.consent) {
      const isConsent = window.Cookiebot.consent.marketing // For authenticated token we check if user has given consent for tracking

      setAuthenticatedUserTokenConsent(isConsent)
    }
    // We execute this every time person changes to detect if the logged user has changed
  }, [person])

  useEffect(() => {
    const handleConsent = () => {
      if (typeof window === 'undefined' || !window.Cookiebot?.consent) return

      const isConsent = window.Cookiebot.consent.marketing
      setUserTokenConsent(isConsent)

      if (person) {
        // For authenticated token we check if user has given consent for tracking
        setAuthenticatedUserTokenConsent(isConsent)
      }
    }

    const initializeAA = () => {
      if (typeof window !== 'undefined') {
        const tokenFromCookie = getCookieFromDocument()
        // const tokenFromStorage = getCookieFromLocalStorage()

        window?.aa?.('init', {
          apiKey: process.env.GATSBY_ALGOLIA_API_KEY ?? '',
          appId: process.env.GATSBY_ALGOLIA_APP_ID ?? '',
          useCookie: !!tokenFromCookie,
          userHasOptedOut: !!!tokenFromCookie,
          cookieDuration: ALGOLIA_COOKIE_DURATION,
        })
      }
    }

    initializeAA() // We initialize insights library
    // handleConsent() // we MUST NOT execute the check on first render

    window.addEventListener(COOKIEBOT_READY, handleConsent)
    window.addEventListener(COOKIEBOT_ACCEPT, handleConsent)
    window.addEventListener(COOKIEBOT_DECLINE, handleConsent)

    return () => {
      window.removeEventListener(COOKIEBOT_READY, handleConsent)
      window.removeEventListener(COOKIEBOT_ACCEPT, handleConsent)
      window.removeEventListener(COOKIEBOT_DECLINE, handleConsent)
    }
  }, [])

  return null
}
